import { images } from "../../constants";

export let projects = [
   {
    imgUrl: images.massageSite,
    projectLink: "https://spimdelaware.netlify.app/#/",
    codeLink: "https://github.com/IonutDragomir/Massage-Site",
    title: "Massage Site",
    description: "A landing page for a massage parlor.",
    tags: ["Vue JS"],
   },
   {
    imgUrl: images.taskTracker,
    projectLink: "https://vue-quasar-task-tracker.netlify.app",
    codeLink: "https://github.com/IonutDragomir/TaskTraker",
    title: "Task Tracker",
    description: "A web app that can help you organize your daily tasks.",
    tags: ["Vue JS","Vuex", "Quasar", "Web app"],
  },
  {
    imgUrl: images.onlineStore,
    projectLink: "",
    codeLink: "https://github.com/IonutDragomir/OnlineStore",
    title: "Online Store",
    description: "Online store is a web page where you can buy products.",
    tags: ["React JS"],
  },
  {
    imgUrl: images.minesweeper,
    projectLink: "https://ionutdragomir.github.io/MineSweeper/main.html",
    codeLink: "https://github.com/IonutDragomir/IonutDragomir.github.io/tree/main/MineSweeper",
    title: "Minesweeper",
    description: "A web page for the classic puzzle and logic game minesweeper.",
    tags: ["Vanilla JS"],
  },
  {
    imgUrl: images.snake,
    projectLink: "https://ionutdragomir.github.io/snakeJS/main.html",
    codeLink: "https://github.com/IonutDragomir/Snake-Game",
    title: "Snake",
    description: "A web page where you can play the classic snake game.",
    tags: ["Vanilla JS"],
  }
];
